import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NzEmbedEmptyComponent } from "ng-zorro-antd/empty";
import { UiEmptyCustomContent } from "@webapp/ui/empty/empty.models";

@Component({
  selector: "ui-embed-empty",
  exportAs: "uiEmbedEmpty",
  templateUrl: "embed-empty.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiEmbedEmptyComponent extends NzEmbedEmptyComponent {
  @Input("uiComponentName") public nzComponentName?: string;
  @Input("uiSpecificContent") public specificContent?: UiEmptyCustomContent;
}
